// extracted by mini-css-extract-plugin
module.exports = {"modal":"popup_modal__1b79k","showModal":"popup_showModal__1MlEl","outer":"popup_outer__LpN6I","close":"popup_close__3EbcS"};